import { dataCardSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCardSolid = /*#__PURE__*/createIcon(dataCardSolid)
export default IconCardSolid
